import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { ResponsiveContainer } from "recharts";
import "./Chart.css";

// Universal wrapper that gives every chart variant a consistent frame:
// title, optional subtitle/action slot, responsive sizing and empty state.
const Chart = ({
  title,
  subtitle,
  action,
  height = 280,
  isEmpty = false,
  emptyMessage = "No data available for the selected period.",
  children,
  className = "",
}) => {
  return (
    <Box className={`app-chart ${className}`.trim()}>
      {(title || subtitle || action) && (
        <Box className="app-chart__header">
          <Box>
            {title && (
              <Typography component="h3" className="app-chart__title">
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography className="app-chart__subtitle">{subtitle}</Typography>
            )}
          </Box>
          {action && <Box>{action}</Box>}
        </Box>
      )}
      <Box className="app-chart__body" style={{ height }}>
        {isEmpty ? (
          <Box className="app-chart__empty">{emptyMessage}</Box>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            {children}
          </ResponsiveContainer>
        )}
      </Box>
    </Box>
  );
};

Chart.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  action: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isEmpty: PropTypes.bool,
  emptyMessage: PropTypes.string,
  children: PropTypes.element.isRequired,
  className: PropTypes.string,
};

export default Chart;
